import React, { forwardRef } from 'react';
import { GripHorizontal } from 'lucide-react';
import { Card } from '../ui/Card';
import { cn } from '../ui/Button';
interface WidgetWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  onRemove?: () => void;
  onDoubleClickHandle?: () => void;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onMouseDown?: React.MouseEventHandler;
  onMouseUp?: React.MouseEventHandler;
  onTouchEnd?: React.TouchEventHandler;
}
export const WidgetWrapper = forwardRef<HTMLDivElement, WidgetWrapperProps>(({
  title,
  onRemove,
  onDoubleClickHandle,
  children,
  className,
  style,
  onMouseDown,
  onMouseUp,
  onTouchEnd,
  ...props
}, ref) => {
  return <Card ref={ref} className={cn('jua-widget flex flex-col h-full bg-[#0B1120] border-slate-800 shadow-lg relative group overflow-hidden', className)} style={style} onMouseDown={onMouseDown} onMouseUp={onMouseUp} onTouchEnd={onTouchEnd} {...props} data-id="element-2023">
        {/* Drag handle strip */}
        <div className="jua-drag-handle draggable-handle flex items-center justify-center h-3.5 flex-shrink-0 cursor-move bg-[#0F172A] border-b border-white/[0.04] hover:bg-[#1a2744] transition-colors" onDoubleClick={e => {
      e.stopPropagation();
      onDoubleClickHandle?.();
    }} title="Double-click to expand to fill row" data-id="element-2024">
          <GripHorizontal size={10} className="text-white/20 group-hover:text-white/40 transition-colors" data-id="element-2025" />
        </div>
        <div className="flex-1 min-h-0 relative overflow-hidden" data-id="element-2026">
          {children}
        </div>
      </Card>;
});